import { RArray, RSet, naturalCompare } from "../collections";
export const PDescription = {
    customParameters(parameterMap, customParameterTypes) {
        return new RArray(parameterMap)
            .map(([parameterType, choiceId]) => {
            var _a, _b;
            return (_b = (_a = customParameterTypes.get(parameterType.id).choices.find(choiceId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "empty";
        })
            .raw.sort(naturalCompare);
    },
    modifier(modifierInstance, modifierType, packagingFeeTypes) {
        return modifierInstance.selectedItems
            .mapOptional((item) => {
            const itemType = modifierType.itemTypes.get(item.typeId);
            const packagingName = item.modifierItemPackagingFeeId !== null
                ? packagingFeeTypes.get(item.modifierItemPackagingFeeId).name.value
                : null;
            return itemType.getNameWithQuantity(item.quantity.value, packagingName);
        })
            .raw.join(", ");
    },
    modifiers(modifierInstances, modifierTypes, packagingFeeTypes, comparator) {
        return modifierInstances
            .sorted((a, b) => comparator(a.typeId, b.typeId))
            .map((instance) => this.modifier(instance, modifierTypes.get(instance.typeId), packagingFeeTypes))
            .filtered((description) => description.trim() !== "").raw;
    },
    orderLine(params) {
        const { productInstance, customParameterTypes, modifierTypes, productTypes, packagingFeeTypes, } = params;
        const customParameters = PDescription.customParameters(productInstance.customParameters.choices, customParameterTypes);
        const nonDivisibleModifiersOrder = RSet.fromIterable(new RArray(productInstance.productTypeIds)
            .mapOptional((id) => productTypes.find(id))
            .flatMap((productType) => new RArray(productType.nonDivisibleModifiersOrder)), { ignoreDuplicates: true }).rawValues();
        const modifiers = PDescription.modifiers(productInstance.commonModifierInstances.objects, modifierTypes, packagingFeeTypes, (a, b) => nonDivisibleModifiersOrder.findIndex((id) => id.eq(a)) -
            nonDivisibleModifiersOrder.findIndex((id) => id.eq(b)));
        const productDesc = customParameters.concat(modifiers);
        const productPackagingFeeName = this.productPackagingFee(productInstance.productPackagingFeeId, packagingFeeTypes);
        // NOTICE: if product is single part type, add also divisible parameters & modifiers
        if (productInstance.parts.type === "SinglePart") {
            const partDesc = PDescription.productPart({
                productInstancePart: productInstance.parts.part,
                modifierTypes,
                productTypes,
                packagingFeeTypes,
            });
            return [productDesc.join(", "), partDesc, productPackagingFeeName !== null && productPackagingFeeName !== void 0 ? productPackagingFeeName : ""]
                .filter((x) => x.trim() !== "")
                .join(", ");
        }
        return productDesc
            .concat(productPackagingFeeName === null ? [] : [productPackagingFeeName])
            .join(", ");
    },
    productPackagingFee(productPackagingFeeId, packagingFeeTypes) {
        if (productPackagingFeeId === null) {
            return null;
        }
        const productPackagingFee = packagingFeeTypes.find(productPackagingFeeId);
        if (productPackagingFee === null) {
            return null;
        }
        const productPackagingFeeName = productPackagingFee.name.value.trim();
        if (productPackagingFeeName === "") {
            return null;
        }
        return productPackagingFeeName;
    },
    productPart(params) {
        const { productInstancePart, modifierTypes, productTypes, packagingFeeTypes, } = params;
        const productType = productTypes.get(productInstancePart.productTypeId);
        const { divisibleModifiersOrder } = productType;
        const modifiers = PDescription.modifiers(productInstancePart.modifierInstances.objects, modifierTypes, packagingFeeTypes, (a, b) => divisibleModifiersOrder.findIndex((id) => id.eq(a)) -
            divisibleModifiersOrder.findIndex((id) => id.eq(b)));
        return modifiers.join(", ");
    },
};
